import { CustomerAPI, json } from '@driftt/dapper'

export const getOrganizations = async () => (
  CustomerAPI.get(`/multi_org`)
    .then(json)
)

export const getOrganizationScopes = async () => (
  CustomerAPI.get(`/multi_org/scopes`)
    .then(json)
)

export const switchOrganization = async (orgId, authClientId) => (
  CustomerAPI.post(`/multi_org/switch?targetOrgId=${orgId}&clientId=${authClientId}`)
    .then(json)
)



// WEBPACK FOOTER //
// ./src/scripts/app/api/OrgAPI.js